<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[fpinvoices$]"></ef-loading-container>
<ef-fixed-price
    [fpinvoices]="fpinvoices"
    [tasks]="filteredByCNTasks"
    (applyMultiUpdateClicked)="onApplyMultiClicked($event)"
    [endDate]="fyEndDate"
    [startDate]="startDate"
    [process]="process$ | async"
    [errors]="errors$ | async"
    [selectedError]="selectedError$ | async"
    (DeleteFixedPrice)="onDeleteFixedPrice($event)"
    (ShowError)="OnShowError($event)"
>
</ef-fixed-price>
